/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import "../styles/globals.scss";
import "@severalbrands/form-fusion/styles";
import * as React from "react";
import type { ReactElement, ReactNode } from "react";
import type { NextPage } from "next";
import { Provider as JotaiProvider } from "jotai";
import { Analytics } from "@vercel/analytics/react";
import {
    QueryClient,
    QueryClientProvider,
    Hydrate,
    DehydratedState,
} from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import DefaultLayout from "@layout/default";
import { useEffect } from "react";
import { useRouter } from "next/router";
import { getUserSessionFromCookies } from "src/api/session";
import { setVisitorInfo } from "@lib/sharedUtils";
import { FormProvider } from "@components/shared/form/formReducer/FormReducer";
import { SpeedInsights } from "@vercel/speed-insights/next";
import { DEFAULT_OPTIONS } from "@lib/reactQueryDefaultOptions";
import { FormProvider as FormFusionProvider } from "@severalbrands/form-fusion";

export type NextPageWithLayout<P = {}, IP = P> = NextPage<P, IP> & {
    getLayout?: (page: ReactElement) => ReactNode;
};

type Props = DehydratedState | any;

export default function MyApp({ Component, pageProps }: Props) {
    const router = useRouter();
    const queryClient = React.useRef(new QueryClient(DEFAULT_OPTIONS));

    useEffect(() => {
        const session = getUserSessionFromCookies();
        if (session) {
            queryClient.current.setQueryData(["session"], session);
            setVisitorInfo(session);
        }
    }, [router.asPath]);

    return (
        <>
            <QueryClientProvider client={queryClient.current}>
                <Hydrate state={pageProps.dehydratedState}>
                    <FormProvider>
                        <JotaiProvider>
                            <FormFusionProvider>
                                <DefaultLayout
                                    pageType={pageProps.pageType}
                                    pageProps={pageProps}
                                >
                                    <Component
                                        key={router.asPath}
                                        {...pageProps}
                                    />
                                </DefaultLayout>
                            </FormFusionProvider>
                        </JotaiProvider>
                    </FormProvider>
                    <ReactQueryDevtools initialIsOpen={false} />
                </Hydrate>
            </QueryClientProvider>
            <SpeedInsights />
            <Analytics />
        </>
    );
}
